var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-file-browser"},[_c('b-card',{staticClass:"c-file-browser"},[_c('MainView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }